import * as navigation from 'Navigation';
import {
  constructOptions,
  ELN_SPELL_CHECK,
  ELN_PRINT_LAYOUT,
  VisibilityOptions,
} from 'settings/visibility-options/VisibilityOptions';

interface ProtocolTabStateDefaults extends navigation.TabStateDefaults {
  displayOptions: VisibilityOptions;
}

class ProtocolTabState extends navigation.TabState {
  defaults(): ProtocolTabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Protocol',
      closeable: false,
      displayOptions: constructOptions('protocol', [
        {base: ELN_SPELL_CHECK, visible: false, editable: true, sync: true},
        {base: ELN_PRINT_LAYOUT, visible: false, editable: true, sync: true},
      ]),
      preferenceKey: 'protocol',
    };
  }
}

export default ProtocolTabState;
